/**
 * Admin Listing Hooks
 * ადმინისტრატორის ლისტინგის ჰუკები
 */

import { useQuery } from '@tanstack/react-query';
import {
  getAdminSubscriptions,
  getAdminWidgets,
  getAdminApiKeys,
  getAdminDataFiles,
  getAdminInvoices,
  type AdminSubscriptionsParams,
  type AdminWidgetsParams,
  type AdminApiKeysParams,
  type AdminDataFilesParams,
  type AdminInvoicesParams,
} from '../features/api/adminListing';

export function useAdminSubscriptions(params: AdminSubscriptionsParams = {}) {
  const query = useQuery({
    queryKey: ['admin', 'subscriptions', params],
    queryFn: () => getAdminSubscriptions(params),
    staleTime: 1000 * 60, // 1 minute
  });

  return {
    subscriptions: query.data?.content ?? [],
    totalElements: query.data?.totalElements ?? 0,
    totalPages: query.data?.totalPages ?? 0,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useAdminWidgets(params: AdminWidgetsParams = {}) {
  const query = useQuery({
    queryKey: ['admin', 'widgets', params],
    queryFn: () => getAdminWidgets(params),
    staleTime: 1000 * 60,
  });

  return {
    widgets: query.data?.content ?? [],
    totalElements: query.data?.totalElements ?? 0,
    totalPages: query.data?.totalPages ?? 0,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useAdminApiKeys(params: AdminApiKeysParams = {}) {
  const query = useQuery({
    queryKey: ['admin', 'api-keys', params],
    queryFn: () => getAdminApiKeys(params),
    staleTime: 1000 * 60,
  });

  return {
    apiKeys: query.data?.content ?? [],
    totalElements: query.data?.totalElements ?? 0,
    totalPages: query.data?.totalPages ?? 0,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useAdminDataFiles(params: AdminDataFilesParams = {}) {
  const query = useQuery({
    queryKey: ['admin', 'data-files', params],
    queryFn: () => getAdminDataFiles(params),
    staleTime: 1000 * 60,
  });

  return {
    dataFiles: query.data?.content ?? [],
    totalElements: query.data?.totalElements ?? 0,
    totalPages: query.data?.totalPages ?? 0,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useAdminInvoices(params: AdminInvoicesParams = {}) {
  const query = useQuery({
    queryKey: ['admin', 'invoices', params],
    queryFn: () => getAdminInvoices(params),
    staleTime: 1000 * 60,
  });

  return {
    invoices: query.data?.content ?? [],
    totalElements: query.data?.totalElements ?? 0,
    totalPages: query.data?.totalPages ?? 0,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
